<script>
/**
 * Изолированный рендер.
 *
 * в больших формах при изменении одного поля, вызывается перендер всего шаблона компонента.
 * Что в некоторых случая становится весьма не быстрым.
 * Компонент позволяет разделить рендер шаблона на независимые части.
 * пример:
 * <v-text-field v-model="a" @hook:updated="$log('a')"></v-text-field>
 * <v-text-field v-model="b" @hook:updated="$log('b')"></v-text-field>
 * <v-text-field v-model="b" @hook:updated="$log('с')"></v-text-field>
 * при изменении любой переменной a,b,c будут перерендерены все компоненты.
 * при "излоировании":
 * <isolated-render v-slot="{}">
 * <v-text-field v-model="a" @hook:updated="$log('a')"></v-text-field>
 * <v-text-field v-model="c" @hook:updated="$log('сa')"></v-text-field>
 * </isolated-render>
 * <isolated-render v-slot="{}">
 * <v-text-field v-model="b" @hook:updated="$log('b')"></v-text-field>
 * <v-text-field v-model="c" @hook:updated="$log('сb')"></v-text-field>
 * </isolated-render>
 * при изменении a, b будет обновлена только соответсвующая часть.
 * при изменении c будут обновлены обе части.
 *
 * Почему это работает и так происходит?
 * Шаблон компилируется в рендер-функцию, примерно так:
 * render(h) {
 *     return h('div', [
 *         h('v-text-field', {props:{value: this.a}, on:{input: (v) => {this.a = v}}}),
 *         h('v-text-field', {props:{value: this.b}, on:{input: (v) => {this.b = v}}}),
 *     ])
 * }
 * рендер функция завист от переменных a и b, т.е. к ним есть обращение при ее вызове.
 * и при их изменении она вызывается.
 * в версии с изолирующим компонентом(и любым scopedSlot вообще) получится примерно так:
 * render(h) {
 *     return h('div', [
 *         h('isolated-render', {scopedSlots: {default: () => {
 *             return h('v-text-field', {props:{value: this.a}, on:{input: (v) => {this.a = v}}})
 *         }}}),
 *         h('isolated-render', {scopedSlots: {default: () => {
 *             return h('v-text-field', {props:{value: this.b}, on:{input: (v) => {this.b = v}}})
 *         }}}),
 *     ])
 * }
 * тут уже рендер-функции не зависит от a и b, к ним нет обращения при ее вызове.
 * на них есть ссылка/замыкание из скомпилорованной рендер-функции слота переданого в изолирующий компонент.
 * т.е. обращания к переменным производятся в изолируещем компоненте при рендере.
 * и таким образом он получает зависимсть от этих переменных, вместо основного компонента/рендер-функции.
 *
 * Примечания:
 * обычный слот не подходит(т.е. v-slot="{}" обязателен), получится примерно:
 * render(h) {
 *     return h('div', [
 *         h('isolated-render', {slots: {default: [
 *             h('v-text-field', {props:{value: this.a}, on:{input: (v) => {this.a = v}}})
 *         ]}}),
 *         h('isolated-render', {slots: {default: [
 *             h('v-text-field', {props:{value: this.b}, on:{input: (v) => {this.b = v}}})
 *         ]}}),
 *     ])
 * }
 *
 * функциональный компонент не подходит
 * т.к. рендерится сразу по месту вставки, не имеет инстанса и не может отслеживать свои зависимости.
 *
 **/
export default {
    name: "IsolatedRender",
    mounted() {
        if (Object.hasOwn(this.$slots, 'default')) {
            console.warn('IsolatedRender: require scopedSlot with v-slot="{}"');
        }
    },
    render() {
        return this.$scopedSlots.default();
    }
}
</script>
